import styled, { css } from 'styled-components';

import { theme, palette } from 'styled-tools';
import Card from '../Card';
// import { HostPlatform } from '../../config/hostPlatform';

// const isMonday = HostPlatform.isMonday();

export const Row = styled(Card)`
  display: grid;
  column-gap: 22px;
  align-items: center;
  justify-items: flex-end;
  ${({ responsive }) =>
    responsive
      ? css`
          width: 100%;
          grid-template-columns: auto 4fr repeat(3, 1.5fr);
          padding: ${theme('spacing.lg')} ${theme('spacing.md')};
        `
      : css`
          width: 80%;
          margin-left: auto;
          margin-right: auto;
          grid-template-columns: 4fr repeat(3, 0.8fr);
          padding: ${theme('spacing.md')} ${theme('spacing.lg')};
        `}
`;

export const Question = styled.div`
  margin-right: auto;
  font-size: ${theme('fontSize.md')};
  text-align: left;
  color: ${palette('colorBody')};
`;
export const RadioBlock = styled.div`
  input[type='radio'] {
    opacity: 0;
    position: fixed;
    width: 0;

    &:checked + label {
      border-color: ${palette('borderInputButton')};
    }
    &:not(:checked) + label {
      &:hover {
        cursor: pointer;
      }
    }
  }
  label {
    display: inline-block;
    padding: 10px;
    border: 2px solid transparent;
    border-radius: 14px;
    ${theme()}
    &:hover {
      border-color: ${palette('borderInput')};
    }
  }
`;

export const Statistic = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  gap: ${theme('spacing.sm')};
  align-items: center;
  span {
    :first-child {
      font-size: ${theme('fontSize.lg')};
      color: ${palette('colorBody')};
    }
  }
  svg {
    opacity: 0.8;
  }
`;

export const VotedCount = styled.div`
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  text-align: center;
  width: 100%;
  color: ${palette('primary')};
  span {
    font-size: 60px;
  }
  small {
    font-size: ${theme('fontSize.xs')};
  }
`;

export const Icon = styled.svg`
  height: 3.2em;
  width: 3.2em;

  ${({ responsive }) =>
    responsive
      ? css`
          @media only screen and (min-width: 800px) and (max-width: 1200px) {
            height: 3em;
            width: 3em;
          }

          @media only screen and (min-width: 300px) and (max-width: 799px) {
            height: 2.1em;
            width: 2.1em;
          }
        `
      : css`
          @media only screen and (min-width: 600px) and (max-width: 800px) {
            height: 3em;
            width: 3em;
          }

          @media only screen and (min-width: 300px) and (max-width: 599px) {
            height: 2.1em;
            width: 2.1em;
          }
        `}
`;
